import { bridge } from '@/common/bridge/methods'
import { BRIDGE_METHODS } from '@/common/bridge/constants'

export default class Click {
  add(entry) {
    // 优先读取 trace-key-click，否则 fallback 到 trace-key
    let traceKey = entry.el.getAttribute('trace-key-click')
    if (!traceKey && entry.el.hasAttribute('trace-key')) {
      traceKey = entry.el.getAttribute('trace-key')
    }
    entry.el.addEventListener('click', function () {
      console.log('点击埋点上报', {
        type: 'onEvent',
        name: traceKey,
        params: JSON.parse(entry.el.attributes['track-params'].value),
      })
      bridge.invokeSync(BRIDGE_METHODS.SEND_TRACK, {
        type: 'onEvent',
        name: traceKey,
        params: JSON.parse(entry.el.attributes['track-params'].value),
      })
    })
  }
}
